import React, { Component } from "react";
//Alert dialog
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { connect } from "react-redux";

class SwtichBranchDialog extends Component {
  render() {
    const language = this.props.language;
    return (
      <Dialog
        open={this.props.dialogOpen}
        onClose={() => this.props.onClose()}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          style={{ textAlign: language == "english" ? "left" : "right" }}
        >
          {language == "english"
            ? "You're about to change the branch"
            : "سوف يتم تغيير الفرع"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            style={{ textAlign: language == "english" ? "left" : "right" }}
          >
            {language === "english"
              ? `This item is for ${
                  this.props.pickupOnly ? "pickup" : "delivery"
                } only. Click yes to change the branch`
              : `هذا المنتج متاح فقط لطلبات ${
                  this.props.pickupOnly ? "الاستلام" : "التوصيل"
                }, إضفط نعم لتغير الفرع`}
          </DialogContentText>
        </DialogContent>
        <DialogActions
          style={{
            justifyContent: language == "english" ? "flex-end" : "flex-start",
          }}
        >
          <Button onClick={() => this.props.yes()} color="primary">
            {language == "english" ? "Yes" : "نعم"}
          </Button>
          <Button onClick={() => this.props.onClose()} color="primary">
            {language == "english" ? "No" : "لا"}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
  };
};

export default connect(mapStateToProps)(SwtichBranchDialog);
